import React, { FC } from 'react';
import { Glyph } from '@edreamsodigeo/prisma-design-system';
import { useBrand } from '@edreamsodigeo/frontend-core';
import { LayerIconProps, AlternativeItineraryLayerIconProps } from './types';

const defaultIconColor = {
  ED: 'info.50',
  OP: 'primary.50',
  GO: 'primary.50',
  TR: 'primary.50',
};

const DefaultColor = (): string => {
  const brand = useBrand();
  return defaultIconColor[brand];
};

const PriceIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-price"
    category="Deals"
    name="TrendingDown"
    color={color}
    size={iconSize}
  />
);

const DiscountIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-discount"
    category="Finances"
    name="Money"
    color={color}
    size={iconSize}
  />
);

const CabinLuggageIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-cabinLuggage"
    category="Baggage"
    name="Medium"
    color={color}
    size={iconSize}
  />
);

const CheckedLuggageIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-checkedLuggage"
    category="Baggage"
    name="Large"
    color={color}
    size={iconSize}
  />
);

const AirportIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-airport"
    category="TimeAndDates"
    name="Future"
    color={color}
    size={iconSize}
  />
);

const ConvenienceIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-convenience"
    category="Planes"
    name="FlightDiagonal"
    color={color}
    size={iconSize}
  />
);

const SocialIcon: FC<LayerIconProps> = ({ iconSize, color }) => (
  <Glyph
    data-testid="alternative-itinerary-layer-icon-social"
    category="User"
    name="Passengers"
    color={color}
    size={iconSize}
  />
);

const iconOptions = {
  price: PriceIcon,
  discount: DiscountIcon,
  cabinLuggage: CabinLuggageIcon,
  checkedLuggage: CheckedLuggageIcon,
  airport: AirportIcon,
  convenience: ConvenienceIcon,
  social: SocialIcon,
};

const AlternativeItineraryLayerIcon: FC<AlternativeItineraryLayerIconProps> = ({
  valueProposition,
  iconSize = 'medium',
  color = DefaultColor(),
}) => {
  const LayerIcon = iconOptions[valueProposition];
  return <LayerIcon iconSize={iconSize} color={color} />;
};

export default AlternativeItineraryLayerIcon;
